import { render } from "./updateRecord.vue?vue&type=template&id=9a080b22&scoped=true&ts=true"
import script from "./updateRecord.vue?vue&type=script&lang=ts"
export * from "./updateRecord.vue?vue&type=script&lang=ts"

import "./updateRecord.vue?vue&type=style&index=0&id=9a080b22&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a080b22"]])

export default __exports__